import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Tabs from "../../../components/tabs/tabs";
import SectionHeader from "../../../components/sectionHeader/sectionHeader";
import Comparativa from "./pages/comparativa/comparativa";
import "./presupuestosBim5d.scss";

const PresupuestosBim5d = () => {
    const [activeTab, setActiveTab] = useState("comparativa");
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        const tabFromUrl = urlParams.get('activeTab');
        if (tabFromUrl) {
            setActiveTab(tabFromUrl);
        }
    }, [location.search]);

    const handleTabChange = (tabId) => {
        setActiveTab(tabId);
        const urlParams = new URLSearchParams(location.search);
        urlParams.set('activeTab', tabId);
        navigate(`${location.pathname}?${urlParams.toString()}`, { replace: true });
    };

    return (
        <div className="presupuestos-bim5d">
            <SectionHeader
                title="Presupuestos BIM 5D"
                subtitle="Comparativa de presupuestos"
            />

            <Tabs
                tabs={[
                    { id: "comparativa", label: "Comparativa" }
                ]}
                activeTab={activeTab}
                onTabChange={handleTabChange}
            />

            <div className="presupuestos-bim5d__content">
                {activeTab === "comparativa" && <Comparativa />}
            </div>
        </div>
    );
};

export default PresupuestosBim5d;